export default __webpack_public_path__ + "static/media/product-07 (1).df2f072e.jpg";